module.exports = __webpack_public_path__ + "img/13.a64796f1.jpg";